import React, { FC } from 'react';
import { MediaType } from '../../../../constants/MediaType';
import { IFileThumbnail } from '../types';
import {
  AnimatedSvgThumbnail,
  DocumentThumbnail,
  MusicThumbnail,
  PictureThumbnail,
  SWFThumbnail,
  UndefinedThumbnail,
  VideoThumbnail,
  ZipThumbnail,
} from './Thumbnails';
import { SiteIconThumbnail } from './Thumbnails/SiteIconThumbnail/SiteIconThumbnail';
import { DocumentWithPreviewThumbnail } from './Thumbnails/DocumentWithPreviewThumbnail';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';

const selectFileThumbnailComponent = ({ mediaType, tags }: MediaManagerSDKFile): FC<IFileThumbnail> => {
  switch (mediaType) {
    case MediaType.SecurePicture:
    case MediaType.Picture:
      return PictureThumbnail;

    case MediaType.VectorArt:
      if (tags.includes('_animated')) {
        return AnimatedSvgThumbnail;
      }
      return PictureThumbnail;

    case MediaType.SiteIcon:
      return SiteIconThumbnail;

    case MediaType.SecureVideo:
    case MediaType.Video:
      return VideoThumbnail;

    case MediaType.SecureMusic:
    case MediaType.Music:
      return MusicThumbnail;

    case MediaType.ThreeD:
    case MediaType.Document:
      return DocumentWithPreviewThumbnail;

    case MediaType.SecureDocument:
    case MediaType.SecureRaw:
      return DocumentThumbnail;

    case MediaType.SecureZip:
    case MediaType.Zip:
      return ZipThumbnail;

    case MediaType.SWF:
      return SWFThumbnail;

    default:
      return UndefinedThumbnail;
  }
};

export const FileThumbnail: FC<IFileThumbnail> = (props) => {
  const ThumbnailComponent = selectFileThumbnailComponent(props.file);

  return <ThumbnailComponent {...props} />;
};
